<template>
    <div>
        <div class="my-3 p-4 bg-white rounded border table-responsive">
            <div class="d-flex align-items-center">
                <select-month :selectedDate="selectedDate" @change="dateChanged"/>

                <div class="ml-auto">
                    <button class="btn btn-secondary" @click="goToday">Today</button>
                </div>
            </div>

            <div class="mt-4">
                <filter-component
                    :campaigns="campaigns"
                    :agreements="agreements"
                    :publishers="publishers"
                    :brands="brands"
                    @campaignChanged="campaignChanged"
                    @agreementChanged="agreementChanged"
                    @publisherChanged="publisherChanged"
                    @brandChanged="brandChanged"
                    />
            </div>

            <calendar-component :selectedDate="selectedDate" @change="dateChanged" :events="events"/>
        </div>

        <table-component :events="events" />
    </div>
</template>

<script>
import SelectMonth from './SelectMonth.vue';
import FilterComponent from './Filter.vue';
import CalendarComponent from './Calendar.vue';
import TableComponent from './Table.vue';
import SelectInput from '../Inputs/SelectInput.vue';

export default {
    components: {
        SelectMonth,
        FilterComponent,
        CalendarComponent,
        TableComponent,
        SelectInput
    },
    props: {
		campaigns: { type: Array, required: true },
        agreements: { type: Array, required: true },
        publishers:  { type: Array, required: true },
        brands:  { type: Array, required: true },
        eventsProp: { type: Array, required:true}
    },
    data() {
        return {
            selectedDate: new Date(),
            selectedCampaign: 0,
            selectedAgreement: 0,
            selectedPublisher: 0,
            selectedBrand: 0,
            events: this.eventsProp
        }
    },
    methods: {
        goToday() {
            this.selectedDate = new Date();
            this.getEvents();
        },
        getEvents() {
            let params = {};
            params.date = this.selectedDate.getFullYear() + '-' + (this.selectedDate.getMonth() + 1).toString().padStart(2, '0') + '-' + this.selectedDate.getDate().toString().padStart(2, '0');
            params.campaign_id = this.selectedCampaign;
            params.agreement_id = this.selectedAgreement;
            params.publisher_id = this.selectedPublisher;
            params.brand_id = this.selectedBrand;

            axios.get('/api/events', { params }).then(response => {
                this.events = response.data.events;
            }).catch(error => {
                console.log(error);
            });
        },
        dateChanged(value) {
            this.selectedDate = value;
            this.getEvents();
        },
        campaignChanged(value) {
            this.selectedCampaign = value;
            this.getEvents();
        },
        agreementChanged(value) {
            this.selectedAgreement = value;
            this.getEvents();
        },
        publisherChanged(value) {
            this.selectedPublisher = value;
            this.getEvents();
        },
        brandChanged(value) {
            this.selectedBrand = value;
            this.getEvents();
        },
    }
}
</script>